/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
export{e as execute,s as supportsCurves}from"../../chunks/centroidOperator.js";import"./support/apiConverter.js";
